import { CardWrapper } from '@anm/components/Card';
import CardModal from '@anm/components/modals/CardModal';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const Content = styled.div`
  pointer-events: all;
`;

const cardModalTablet = media.tablet`
  height: auto;
`;

export const ModalWrapper = styled(CardModal)`
  width: 580px;
  max-width: 100%;
  border-radius: 5px;
  ${CardWrapper} {
    width: 100%;
  }
  ${cardModalTablet};
`;

export default Content;
